import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { createMetadataGenerator, resolvePageName } from '../utils/metadataGenerator';
import { RolePlayData, RolePlaySettings } from '../types/feedback';

interface UseMetadataProps {
  currentUser: any;
  sessionId?: string;
  rolePlayData?: RolePlayData;
  rolePlaySettings?: RolePlaySettings;
  screenshot?: string | null;
}

export const useMetadata = ({
  currentUser,
  sessionId,
  rolePlayData,
  rolePlaySettings,
  screenshot
}: UseMetadataProps) => {
  const location = useLocation();

  const metadataGenerator = useMemo(() => {
    return createMetadataGenerator({
      currentUser,
      location,
      sessionId,
      rolePlayData,
      rolePlaySettings,
      screenshot
    });
  }, [currentUser, location, sessionId, rolePlayData, rolePlaySettings, screenshot]);

  return {
    generateMetadata: () => metadataGenerator.generateMetadata(),
    getMetadataItemCount: () => metadataGenerator.getMetadataItemCount(),
    // Both of these used to be re-implemented here, including a second copy of
    // the page map with the same substring bug. The generator owns the logic;
    // the preview UI and the submitted metadata must agree.
    getCurrentPageName: () => resolvePageName(location.pathname),
    getRolePlaySettingsMetadata: () => metadataGenerator.getRolePlaySettingsMetadata(),
  };
};